import React from "react";
import "./style.css";

const Autobot = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const autobotParam = urlParams.get("autobot");

  if (autobotParam !== "true") {
    // Se o parâmetro 'autobot' não for 'true', não renderize o componente
    return null;
  }

  const clickButtons = () => {
    return new Promise((resolve) => {
      const container = document.querySelectorAll(".answer-buttons-container");

      if (!container.length) {
        resolve();
        return;
      }

      let completedContainers = 0;

      container.forEach((conts, index) => {
        setTimeout(() => {
          const buttons = conts.children;

          const randomIndex = Math.floor(Math.random() * 4);
          buttons[randomIndex].children[0].click();

          completedContainers++;

          if (completedContainers === container.length) {
            resolve();
          }
        }, index * 500);
      });
    });
  };

  const clickNextButton = async () => {
    let nextButton = Array.from(document.querySelectorAll(".button-start-test"));

    nextButton = nextButton[nextButton.length - 1].children[0];
    if (nextButton) {
      nextButton.click();
      await new Promise((resolve) => setTimeout(resolve, 500)); // Aguarda 500ms
    }
  };

  const performClicks = async () => {
    for (let i = 0; i < 14; i++) {
      await clickButtons();
      await clickNextButton();
    }
  };

  const startBot = () => {
    performClicks();
  };

  return (
    <div className="autobot-button-container">
      <button onClick={startBot}>Iniciar Bot</button>
    </div>
  );
};

export default Autobot;
